import React from 'react';
import { useIntl } from 'umi';
import { Button, Modal } from 'tea-component';
import MultipleChoice from '@/pages/intelligence/components/MultipleChoice';
import { ECHARTSCOLOR } from '@/pages/intelligence/utils/echartsConst';
import { MAXGAMENUM } from '@/pages/intelligence/pages/TopCharts/_config/topChartsConst';

export type TableSelectStatusType = 'add' | 'del' | 'all' | 'cancel';

export interface TableSelectionType {
  gameId: string;
  color: string;
  [propName: string]: any;
}

interface TableCheckboxHeaderProps {
  selectList: TableSelectionType[];
  disableChckekList?: string[];
  tableSelectionAll: TableSelectionType[];
  disabled?: boolean;
  onChange: (list: any[], status: TableSelectStatusType) => void;
}

interface TableCheckboxRenderProps {
  selectList: TableSelectionType[];
  cvm: TableSelectionType;
  onChange: (list: TableSelectionType[], status: TableSelectStatusType) => void;
  disabled?: boolean;
  bubbleContent?: React.ReactNode;
}

export const TableCheckboxHeader = (props: TableCheckboxHeaderProps) => {
  const {
    selectList = [],
    disableChckekList = [],
    tableSelectionAll = [],
    disabled,
    onChange = () => console.log,
  } = props;
  let selectAll = false;
  if (selectList?.length === tableSelectionAll?.length && selectList?.length > 0) {
    selectAll = selectList?.every((t) => (
      tableSelectionAll.filter((item) => item?.gameId === t.gameId).length > 0
    ));
  }
  return (
    <MultipleChoice
      value={selectAll}
      indeterminate={selectAll === false && selectList?.length > 0}
      disabled={disabled}
      onChange={() => {
        // 如果有禁用的勾选并且取消全选时，再次点击全选要选上
        const realList = selectList?.filter(t => {
          return !(disableChckekList?.includes(t?.gameId));
        });
        if (realList?.length > 0) {
          // 取消全选
          onChange([], 'cancel');
        } else {
          /** 全选 */
          onChange(tableSelectionAll, 'all');
        }
      }}
    />
  );
};

export const TableCheckboxRender = (props: TableCheckboxRenderProps) => {
  const { selectList = [], cvm, onChange = () => console.log, disabled, bubbleContent } = props;
  const { formatMessage } = useIntl();
  const gameId = cvm?.gameId || cvm?.id || cvm?.unifiedId || cvm?.app_id;
  const selected = selectList?.find((t) => gameId === t.gameId);
  return (
    <MultipleChoice
      value={gameId && gameId === selected?.gameId}
      disabled={disabled}
      bubbleContent={bubbleContent}
      color={selected?.color}
      onChange={(v: boolean) => {
        if (v) {
          if (selectList.length >= MAXGAMENUM) {
            Modal.error({
              size: 'm',
              // message: 'Sorry,',
              // description: `Please select ${MAXGAMENUM} items at most for the best visualization experience.`,
              message: formatMessage({ id: 'dbi_top_charts_table_selection_limit_title' }),
              description: formatMessage({ id: 'dbi_top_charts_table_selection_limit_tips' }, { num: MAXGAMENUM }),
              buttons: [<Button type="primary">{formatMessage({ id: 'dbi_confirm' })}</Button>],
            });
            return;
          }
          /** 添加元素 */
          const newUpdataColors = selectList?.map((t, i) => ({
            ...t,
            color: ECHARTSCOLOR[i],
          }));
          const newSelectList = [
            ...newUpdataColors,
            {
              ...cvm,
              gameId, // value
              color: ECHARTSCOLOR[selectList?.length],
            },
          ];
          onChange(newSelectList, 'add');
        } else {
          // 移除元素
          const newSelectList = selectList?.filter((t) => t.gameId !== gameId);
          const newUpdataColors = newSelectList?.map((t, i) => ({
            ...t,
            color: ECHARTSCOLOR[i],
          }));
          onChange(newUpdataColors, 'del');
        }
      }}
    />
  );
};
